import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const daysLimitInput = style(
  {
    width: '40px',
  },
  'days-limit-input',
);

/**
 * The diagnostic digest is newline-formatted by whatever built it, so preserve those breaks and
 * cap the height — a long snapshot must not push the submit button off screen.
 */
export const diagnosticsSummary = style(
  {
    whiteSpace: 'pre-wrap',
    overflowY: 'auto',
    maxHeight: '160px',
    fontFamily: themeVars['font-family'].mono,
    backgroundColor: themeVars.color['overlay-tint'],
    borderRadius: themeVars.radius['4'],
    padding: themeVars.space['150'],
  },
  'diagnostics-summary',
);
